// extracted by mini-css-extract-plugin
export default {"logo":"Menu_logo__U3ED-","menubutton":"Menu_menubutton__9bdBU","widgetmenu":"Menu_widgetmenu__Agt4T"};